import React, {useEffect, useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  FlatList,
  ActivityIndicator,
  Linking,
  TouchableHighlight,
} from 'react-native';
import {Color, globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import Header from '../../../commonComponents/Header';
import TxnCard from '../childComponents/txnCard';
import {getWalletTransactions} from '../redux/wallet.action';
import {connect, useSelector} from 'react-redux';
import {countryRegion, isMobile} from '../../../utils/commonMethods';
import {SafeAreaView} from 'react-native-safe-area-context';
import {globalImport} from '../../../common/globalImports';
import FastImage from '../../../common/FastImage';
import {
  info,
  passbook_question,
  popup_credit,
  popup_debit,
  right_icon,
  transactions_add,
  transactions_invest,
  transactions_sub,
  transactions_withdraw,
} from '../../../utils/images';
import RupeeVal from '../../../commonComponents/RupeeVal';
import moment from 'moment/moment';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import {
  globalConfigurableData,
  globalConst,
  GlobalScreens,
} from '../../../utils/globalConstant';
import Tooltip from 'react-native-walkthrough-tooltip';

// const transaction = {title: 'Withdraw',
// status: 'in process',
// amount: '-9,995.00',
// info: 'BTC USDT will stay between the range of 26659.944 - 26893.685 from 01:00 PM to 03:00 PM?',
// metadata: [
//     {key: 'Amount',value: '9995.00'},
//     {key: 'Fees',value: '5.00'},
//     {key: 'Transaction ID',value: '#P000156397532943'},
//     {key: 'Date',value: '18 March 23, 12:15 PM'}]
// };

const TransactionScreen = ({transaction, navigation, route, typeTxn}) => {
  const [toolTipVisible, setToolTipVisible] = useState(false);
  if (route?.params) {
    transaction = route?.params?.transaction;
    typeTxn = route?.params?.typeTxn;
  }
  const globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );

  const onLinkClick = link => {
    if (link) {
      Linking.openURL(link);
    }
  };

  const dateFormat = time => {
    return moment.utc(time).local().format('MMMM DD, YYYY hh:mm a');
  };

  return (
    <SafeAreaView style={[globalStyle.pageContainer, {flexGrow: 1}]}>
      <Header
        isInternalPage={false}
        navigation={navigation}
        pageName={''}
        isBackgroundColor={false}
        backGroundColor={GlobalScreens.Wallet.transactionBox}
      />

      <View style={styles.topBox}>
        <FastImage
          style={{width: 55, height: 55}}
          source={
            transaction?.title === 'Withdraw'
              ? globalConfigurableData?.transactions_withdraw()
              : transaction?.title === 'Invested in Event'
              ? globalConfigurableData?.transactions_invest()
              : transaction?.title === 'Market Settled' ||
                transaction?.title === 'Deposit' ||
                transaction?.title === 'Order Cancelled' ||
                typeTxn === 'CREDIT'
              ? globalConfigurableData?.transactions_add()
              : transactions_sub()
          }></FastImage>
        <FormTextLabel
          labelStyles={{
            ...globalFontStyle.appFontSubText,
            color: globalConfigurableData.primaryTextColor1,
            marginTop: 15,
          }}
          label={transaction?.title}
        />
        <RupeeVal
          customStyle={{
            ...globalFontStyle.appBlueHead,
            color: globalConfigurableData.primaryTextColor1,
            marginTop: 5,
          }}
          rupeeVal={transaction?.amount || 0}
        />
        {transaction?.info && (
          <Text
            style={{
              ...globalFontStyle.appFontSubText,
              color: globalConfigurableData.primaryTextColor1,
              marginTop: 15,
              textAlign: 'center',
            }}>
            {transaction?.info}
          </Text>
        )}
        {transaction?.status && (
          <FormTextLabel
            labelStyles={[
              styles.statusText,
              {
                backgroundColor:
                  transaction?.status === 'in process'
                    ? '#FFDC5D'
                    : transaction?.status === 'Failed'
                    ? '#A8200D'
                    : '#00AA51',
                color:
                  transaction?.status === 'in process'
                    ? Colors.black
                    : Colors.bgWhite,
              },
            ]}
            label={transaction?.status}
          />
        )}
      </View>
      <View style={{paddingHorizontal: 16}}>
        <FormTextLabel
          labelStyles={{
            ...globalFontStyle.appFontTitle,
            color: globalConfigurableData.primaryTextColor1,
            paddingVertical: 15,
          }}
          label={'Transactions Details'}
        />
        {transaction?.metadata?.map((data, i) => {
          return (
            <View
              key={i}
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingVertical: 10,
              }}>
              <View style={{flexDirection: 'row', alignItems: 'center'}}>
                <Text
                  style={{
                    ...globalFontStyle.appFontSubText,
                    color: globalConfigurableData.primaryTextColor1,
                  }}>
                  {data?.key}
                </Text>
                {data?.key === 'All Cost & Fees' &&
                  globalConst.partnerId === 1 && (
                    <Tooltip
                      isVisible={toolTipVisible}
                      contentStyle={[
                        globalStyle.toolTipStyle,
                        !isMobile() ? {flex: 1, minWidth: 150} : null,
                      ]}
                      content={
                        <View style={{}}>
                          <FormTextLabel
                            labelStyles={{
                              ...globalFontStyle.appFontSubText,
                              color: globalConfigurableData.primaryTextColor1,
                            }}
                            label={'All cost & fees\n'}
                          />
                          <TouchableOpacity
                            activeOpacity={0.8}
                            onPress={() => {
                              onLinkClick(globalConfigData?.feeLink);
                            }}>
                            <FormTextLabel
                              labelStyles={{
                                ...globalFontStyle.appFontSubTextBold,
                                color: GlobalScreens.Wallet.highlightColor,
                              }}
                              label={'Learn More'}
                            />
                          </TouchableOpacity>
                        </View>
                      }
                      placement="top"
                      onClose={() => setToolTipVisible(false)}
                      showChildInTooltip={false}
                      disableShadow={true}
                      backgroundColor={'rgba(0,0,0)'}
                      allowChildInteraction={true}>
                      <TouchableHighlight
                        style={globalStyle.infoIcon}
                        onPress={() => setToolTipVisible(true)}>
                        <FastImage
                          style={{
                            width: 15,
                            height: 15,
                          }}
                          source={globalConfigurableData?.info()}
                        />
                      </TouchableHighlight>
                    </Tooltip>
                  )}
              </View>
              <Text
                style={{
                  ...globalFontStyle.appFontSubText,
                  color: globalConfigurableData.primaryTextColor1,
                  textAlign: 'right',
                }}>
                {data?.key === 'Date' ? dateFormat(data?.value) : data?.value}
              </Text>
            </View>
          );
        })}
      </View>
      {globalConst.partnerId === 1 && (
        <View>
          <View style={{...styles.line, marginTop: 20}} />
          <TouchableOpacity
            onPress={() => {
              onLinkClick(globalConfigData?.supportUrl);
            }}>
            <FormTextLabel
              labelStyles={{
                ...globalFontStyle.appFontSubTextBold,
                color: GlobalScreens.Wallet.highlightColor,
                textAlign: 'center',
                paddingVertical: 15,
                textDecorationLine: 'underline',
              }}
              label={'Noticed an error? Contact us'}
            />
          </TouchableOpacity>
          <View style={styles.line} />
        </View>
      )}
    </SafeAreaView>
  );
};

export default TransactionScreen;

const styles = StyleSheet.create({
  statusText: {
    marginTop: 15,
    paddingVertical: 8,
    paddingHorizontal: 20,
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.contrastTextColor1,
    borderRadius: 100,
  },
  topBox: {
    paddingVertical: 20,
    marginBottom: 20,
    backgroundColor: GlobalScreens.Wallet.transactionBox,
    alignItems: 'center',
    paddingHorizontal: 25,
  },
  line: {
    borderBottomColor: globalConfigurableData.borderColor,
    borderBottomWidth: 1,
    borderStyle: 'dashed',
  },
});
